import { ReactNode } from 'react';
import styled, { keyframes } from 'styled-components';

export interface Props {
  duration?: number;
  delay?: number;
  children: ReactNode;
}

export const FadeIn = ({ duration = 300, delay = 0, children }: Props) => {
  return (
    <Wrapper
      style={{
        animationDuration: duration + 'ms',
        animationDelay: delay + 'ms',
      }}
    >
      {children}
    </Wrapper>
  );
};

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  @media (prefers-reduced-motion: no-preference) {
    animation-name: ${fadeInAnimation};
    animation-fill-mode: backwards;
  }
`;
